import { NavSidebarRowItem, NavSidebarParentRowItem } from '@mt-ng2/nav-module-config';

// tslint:disable:object-literal-sort-keys
export const appNavMenu: (NavSidebarRowItem | NavSidebarParentRowItem)[] = [];
// tslint:enable:object-literal-sort-keys
